<template>
  <!-- 框架 -->
  <div class="frame" style="text-align: initial">
    <div class="frame-in">
      <!-- 左侧菜单栏 -->
      <div :class="{ 'menu-mini': !collapsed }">
        <div class="frame-left frame-float-clear">
          <div class="frame-menu-pannel">
            <!--{{ window.location.hash }}-->
          </div>
          <!-- 导航菜单 -->
          <div class="frame-menu-list">
            <div
              class="frame-menu-item"
              v-for="menu in validMenu"
              :key="menu.url"
              :class="{ 'frame-menu-item-active': menu.url === expandMenu }"
            >
              <div
                class="frame-menu-item-title"
                @click="
                  expandMenu = menu.url
                  currentUrl = menu.url
                "
              >
                <i :class="menu.icon"></i>
                <a
                  :href="'#/' + menu.url"
                  :class="{
                    'frame-menu-item-title-active': menu.url === expandMenu,
                  }"
                  >{{ menu.title }}</a
                >
              </div>
              <!-- 子菜单 -->
              <div
                class="frame-sub-item-list"
                :style="
                  expandMenu !== menu.url
                    ? { height: '0px' }
                    : { height: menu.subs.length * 40 + 'px' }
                "
              >
                <div
                  class="frame-sub-item"
                  v-for="sub in menu.subs"
                  :key="sub.url"
                  @click="currentUrl = sub.url"
                >
                  <a
                    :href="'#/' + currentUrl"
                    :class="{ 'frame-sub-item-active': currentUrl === sub.url }"
                  >
                    {{ sub.title }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧主体 -->
      <div
        class="frame-right frame-float-clear"
        :class="{ 'frame-right-stretch': !collapsed }"
      >
        <div class="frame-right-in frame-relative">
          <!-- 右侧顶部 -->
          <div class="frame-right-top">
            <div class="frame-inline-block" style="margin-left: 20px">
              <img
                src="../image/collapsed.png"
                height="50"
                @click="collapsed = !collapsed"
                style="cursor: pointer"
                :class="{
                  'frame-roate': !collapsed,
                  'frame-roatecol': collapsed,
                }"
              />
            </div>
            <!--
            <div class="frame-log-icon frame-inline-block">
              <img src="../image/gcom.png" height="30" />
            </div>
            -->

            <div class="frame-inline-block">
              <span class="frame-product-title">
                {{ "GPON-OLT-" + ("0" + ponnum).slice(-2) + "P" }}
              </span>
            </div>
            <!-- 顶部右侧 -->
            <div class="frame-right-top-right">
              <span style="padding-right: 15px">{{ username }}</span>
              <select class="form-control" v-model="select_lang">
                <option>English</option>
                <!--<option>Chinese</option>-->
              </select>
              <span>
                <div v-show="false">
                  <i
                    class="fa glyphicon glyphicon-question-sign"
                    title="Help"
                  ></i>
                </div>
                <!--
                <i
                  class="fa glyphicon glyphicon-info-sign"
                  @click="clickAboutBoxIcon($event)"
                  title="About"
                ></i>-->
                <i
                  class="fa glyphicon glyphicon-log-out"
                  title="Log out"
                  @click="logout()"
                ></i>
              </span>
            </div>
          </div>
          <!-- 页面内容 -->
          <div class="frame-right-main" style="height: auto">
            <div style="height: auto" :class="{ 'pageTitle-mini': !collapsed }">
              <div class="frame-right-main-page">
                <!-- 速配 -->
                <div v-if="need_fastconfig">
                  <!-- 配置 0 -->
                  <div v-if="fast_dialog == 0">
                    <dialog-box
                      :x="false"
                      :btitle="'Setup Guide'"
                      @close="need_fastconfig = false"
                      :closeButton="true"
                      style="min-height: 0px"
                    >
                      <form class="form-horizontal" role="form">
                        <div
                          class="form-group"
                          style="margin: 10px 10px 20px 10px"
                        >
                          This setup guid is used to configure basic service
                          parameters for ONT registration and enable traffic.
                          Click next to continue. To perform detailed
                          configuration, click Cancel to enter the main menu for
                          configuration.
                        </div>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="margin-left: 70%; min-width: 77px"
                          @click="clkCancel()"
                        >
                          {{ "Cancel" }}
                        </button>
                        <span style="margin-left: 10px">
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="min-width: 77px"
                            @click="fast_dialog++"
                          >
                            {{ "Next" }}
                          </button>
                        </span>
                      </form>
                    </dialog-box>
                  </div>
                  <!-- 配置 1 -->
                  <div v-if="fast_dialog == 1">
                    <dialog-box
                      :x="false"
                      :btitle="'Ont mode'"
                      @close="need_fastconfig = false"
                      :closeButton="true"
                      style="min-height: 0px"
                    >
                      <form class="form-horizontal" role="form">
                        <div class="form-group">
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="margin-left: 20%; min-width: 77px"
                            @click="
                              fast_dialog++
                              fastconfig.ontsfumode = false
                            "
                          >
                            {{ "HGU" }}
                          </button>
                          <span style="margin-left: 10px">
                            <button
                              type="button"
                              class="btn btn-primary"
                              style="min-width: 77px"
                              @click="
                                fast_dialog += 2
                                fastconfig.ontsfumode = true
                              "
                            >
                              {{ "SFU" }}
                            </button>
                          </span>
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-left: 70%; min-width: 77px"
                          @click="fast_dialog--"
                        >
                          {{ "Back" }}
                        </button>
                      </form>
                    </dialog-box>
                  </div>
                  <!-- 配置 2 -->
                  <div v-if="fast_dialog == 2">
                    <dialog-box
                      :x="false"
                      :btitle="'HGU'"
                      @close="need_fastconfig = false"
                      :closeButton="true"
                      style="min-height: 0px"
                    >
                      <form class="form-horizontal" role="form">
                        <div
                          class="form-group"
                          v-for="(value, key) in ['HSI', 'SIP', 'IPTV']"
                          :key="key"
                        >
                          <input
                            type="checkbox"
                            class="form-control"
                            :id="'fastconfig_' + value"
                            v-model="fastconfig[value]"
                          />
                          <label
                            class="col-sm-2 control-label"
                            :for="'fastconfig_' + value"
                            style="padding-left: 30px; text-align: left"
                            @click="
                              fastconfig[value]
                                ? (fastconfig[value + 'Vlan'] = null)
                                : ''
                              fastconfig.hguTip = false
                            "
                            >{{ value }}</label
                          >
                          <label
                            class="col-sm-2 control-label"
                            :for="'fastconfig_' + value + '_vlan'"
                            >vlan</label
                          >
                          <div
                            class="col-sm-5"
                            :class="{
                              'has-error': input_hgu_vlan_check(key),
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              :id="'fastconfig_' + value + '_vlan'"
                              v-model="fastconfig[value + 'Vlan']"
                              placeholder="INTEGER<2-4094>"
                              autocomplete="off"
                              :disabled="!fastconfig[value]"
                            />
                            <small
                              class="help-block"
                              v-if="input_hgu_vlan_check(key)"
                              >{{ input_hgu_vlan_check(key) }}
                            </small>
                          </div>
                        </div>
                        <div class="form-group" v-if="fastconfig.hguTip">
                          <div
                            class="col-sm-12"
                            :class="{
                              'has-error': true,
                            }"
                          >
                            <small
                              class="help-block"
                              style="padding-left: 15px"
                            >
                              <span
                                class="
                                  glyphicon glyphicon-warning-sign
                                  icon-severity-warn
                                "
                                style="margin-right: 10px"
                              ></span
                              >{{ "paramaters should not be empty!" }}
                            </small>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-left: 70%; min-width: 77px"
                          @click="fast_dialog--"
                        >
                          {{ "Back" }}
                        </button>
                        <span style="margin-left: 10px">
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="min-width: 77px"
                            @click="hguNext()"
                          >
                            {{ "Next" }}
                          </button>
                        </span>
                      </form>
                    </dialog-box>
                  </div>
                  <!-- 配置 3 -->
                  <div v-if="fast_dialog == 3">
                    <dialog-box
                      :x="false"
                      :btitle="'SFU'"
                      @close="need_fastconfig = false"
                      :closeButton="true"
                      style="min-height: 0px"
                    >
                      <form class="form-horizontal" role="form">
                        <div
                          class="form-group"
                          v-for="(value, key) in [
                            'Lan1',
                            'Lan2',
                            'Lan3',
                            'Lan4',
                          ]"
                          :key="key"
                        >
                          <input
                            type="checkbox"
                            class="form-control"
                            :id="'fastconfig_' + value"
                            v-model="fastconfig[value]"
                          />
                          <label
                            class="col-sm-2 control-label"
                            :for="'fastconfig_' + value"
                            style="padding-left: 30px; text-align: left"
                            @click="
                              fastconfig[value]
                                ? ((fastconfig[value + 'Mode'] = 'tag'),
                                  (fastconfig[value + 'Vlan'] = null),
                                  (fastconfig[value + 'VlanT'] = null))
                                : ''
                              fastconfig.sfuTip = false
                            "
                            >{{ value }}</label
                          >
                          <label
                            class="col-sm-1 control-label"
                            :for="'fastconfig_' + value + '_mode'"
                            >Mode</label
                          >
                          <div class="col-sm-3">
                            <select
                              class="form-control"
                              :id="'fastconfig_' + value + '_mode'"
                              v-model="fastconfig[value + 'Mode']"
                              :disabled="!fastconfig[value]"
                            >
                              <option value="tag">Tag</option>
                              <option value="trunk">Trunk</option>
                              <option value="translate">Translate</option>
                            </select>
                          </div>
                          <label
                            class="col-sm-2 control-label"
                            :for="'fastconfig_' + value + '_vlan'"
                            >vlan</label
                          >
                          <div
                            class="col-sm-4"
                            :class="{
                              'has-error': input_vlanid_check(
                                fastconfig[value + 'Vlan']
                              ),
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              :id="'fastconfig_' + value + '_vlan'"
                              v-model="fastconfig[value + 'Vlan']"
                              placeholder="INTEGER<2-4094>"
                              autocomplete="off"
                              :disabled="!fastconfig[value]"
                            />
                            <small
                              class="help-block"
                              v-if="
                                input_vlanid_check(fastconfig[value + 'Vlan'])
                              "
                              >{{
                                input_vlanid_check(fastconfig[value + "Vlan"])
                              }}
                            </small>
                          </div>
                          <div
                            v-if="fastconfig[value + 'Mode'] === 'translate'"
                          >
                            <div class="col-sm-12" style="height: 5px"></div>
                            <div class="col-sm-6"></div>
                            <label
                              class="col-sm-2 control-label"
                              :for="'fastconfig_' + value + '_vlanT'"
                              >new vlan
                            </label>
                            <div
                              class="col-sm-4"
                              :class="{
                                'has-error': input_vlanid_check(
                                  fastconfig[value + 'VlanT']
                                ),
                              }"
                            >
                              <input
                                type="text"
                                class="form-control"
                                :id="'fastconfig_' + value + '_vlanT'"
                                v-model="fastconfig[value + 'VlanT']"
                                placeholder="INTEGER<2-4094>"
                                autocomplete="off"
                                :disabled="!fastconfig[value]"
                              />
                              <small
                                class="help-block"
                                v-if="
                                  input_vlanid_check(
                                    fastconfig[value + 'VlanT']
                                  )
                                "
                                >{{
                                  input_vlanid_check(
                                    fastconfig[value + "VlanT"]
                                  )
                                }}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div class="form-group" v-if="fastconfig.sfuTip">
                          <div
                            class="col-sm-12"
                            :class="{
                              'has-error': true,
                            }"
                          >
                            <small
                              class="help-block"
                              style="padding-left: 15px"
                            >
                              <span
                                class="
                                  glyphicon glyphicon-warning-sign
                                  icon-severity-warn
                                "
                                style="margin-right: 10px"
                              ></span
                              >{{ "paramaters should not be empty!" }}
                            </small>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-left: 70%; min-width: 77px"
                          @click="fast_dialog -= 2"
                        >
                          {{ "Back" }}
                        </button>
                        <span style="margin-left: 10px">
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="min-width: 77px"
                            @click="sfuNext()"
                          >
                            {{ "Next" }}
                          </button>
                        </span>
                      </form>
                    </dialog-box>
                  </div>
                  <!-- 配置 4 -->
                  <div v-if="fast_dialog == 4">
                    <dialog-box
                      :x="false"
                      :btitle="'Manage IP Config'"
                      @close="need_fastconfig = false"
                      :closeButton="true"
                      style="min-height: 0px"
                    >
                      <form class="form-horizontal" role="form">
                        <div class="form-group">
                          <input
                            type="checkbox"
                            class="form-control"
                            id="fastconfig_manageIp"
                            v-model="fastconfig.manageIp"
                          />
                          <label
                            class="col-sm-12 control-label"
                            for="fastconfig_manageIp"
                            style="padding-left: 30px; text-align: left"
                            @click="
                              fastconfig.manageIpVlan = null
                              fastconfig.manageIpAddr = null
                              fastconfig.manageIpMask = null
                              fastconfig.manageIpGateway = null
                            "
                            >Manage IP Config</label
                          >
                        </div>
                        <div class="form-group">
                          <label
                            class="col-sm-3 control-label"
                            for="fastconfig_manageIpVlan"
                            >vlan</label
                          >
                          <div
                            class="col-sm-5"
                            :class="{
                              'has-error': input_vlanid_check(
                                fastconfig.manageIpVlan
                              ),
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              id="fastconfig_manageIpVlan"
                              v-model="fastconfig.manageIpVlan"
                              placeholder="INTEGER<2-4094>"
                              autocomplete="off"
                              :disabled="!fastconfig.manageIp"
                            />
                            <small
                              class="help-block"
                              v-if="input_vlanid_check(fastconfig.manageIpVlan)"
                              >{{ input_vlanid_check(fastconfig.manageIpVlan) }}
                            </small>
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            class="col-sm-3 control-label"
                            for="fastconfig_manageIpAddr"
                            >IP</label
                          >
                          <div
                            class="col-sm-5"
                            :class="{
                              'has-error': input_manageIp_check(0),
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              id="fastconfig_manageIpAddr"
                              v-model="fastconfig.manageIpAddr"
                              autocomplete="off"
                              :disabled="!fastconfig.manageIp"
                            />
                            <small
                              class="help-block"
                              v-if="input_manageIp_check(0)"
                              >{{ input_manageIp_check(0) }}
                            </small>
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            class="col-sm-3 control-label"
                            for="fastconfig_manageIpMask"
                            >mask</label
                          >
                          <div
                            class="col-sm-5"
                            :class="{
                              'has-error': input_ipmask_check(
                                fastconfig.manageIpMask
                              ),
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              id="fastconfig_manageIpMask"
                              v-model="fastconfig.manageIpMask"
                              autocomplete="off"
                              :disabled="!fastconfig.manageIp"
                            />
                            <small
                              class="help-block"
                              v-if="input_ipmask_check(fastconfig.manageIpMask)"
                              >{{ input_ipmask_check(fastconfig.manageIpMask) }}
                            </small>
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            class="col-sm-3 control-label"
                            for="fastconfig_manageIpGateway"
                            >gateway</label
                          >
                          <div
                            class="col-sm-5"
                            :class="{
                              'has-error': input_manageIp_check(1),
                            }"
                          >
                            <input
                              type="text"
                              class="form-control"
                              id="fastconfig_manageIpGateway"
                              v-model="fastconfig.manageIpGateway"
                              autocomplete="off"
                              :disabled="!fastconfig.manageIp"
                            />
                            <small
                              class="help-block"
                              v-if="input_manageIp_check(1)"
                              >{{ input_manageIp_check(1) }}
                            </small>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-left: 70%; min-width: 77px"
                          @click="fast_dialog -= fastconfig.ontsfumode ? 1 : 2"
                        >
                          {{ "Back" }}
                        </button>
                        <span style="margin-left: 10px">
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="min-width: 77px"
                            @click="clkApply()"
                          >
                            {{ "Finish" }}
                          </button>
                        </span>
                      </form>
                    </dialog-box>
                  </div>
                </div>
                <router-view></router-view>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于信息对话框 -->
    <!--<about-box about-box-data-model="aboutBoxDataModel"></about-box>-->
    <!-- 页面加载框 -->
    <div v-show="false">
      <div
        class="modal"
        width="100%"
        height="100%"
        style="
          display: block;
          position: fixed;
          background: #000;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 100000;
          filter: alpha(opacity=50);
          opacity: 0.1;
        "
      ></div>
      <div
        class="modal-dialog"
        width="100%"
        height="100%"
        style="
          position: fixed;
          left: 0;
          right: 0;
          top: 25%;
          width: 400px;
          z-index: 100001;
        "
      >
        <div class="modal-content">
          <div
            class="modal-body"
            style="background: #fff; width: 400px; padding: 20px"
          >
            <table>
              <tr>
                <td><i class="fa fa-spinner fa-pulse fa-4x fa-fw"></i></td>
                <td align="center" width="200px">Loading...</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
// @ is an alias to /src
import Home from "./Home.vue"
import DeviceStatus from "./DeviceStatus.vue"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "frame",

  components: {
    Home,
    DeviceStatus,
    InfoBox,
    DialogBox,
  },
  data() {
    return {
      collapsed: true,
      expandMenu: "",
      currentUrl: "",
      username: "",
      ponnum: 0,
      need_fastconfig: false,
      fast_dialog: 0,
      fastconfig: {
        ontsfumode: false,
        HSI: false,
        HSIVlan: null,
        SIP: false,
        SIPVlan: null,
        IPTV: false,
        IPTVVlan: null,
        hguTip: false,
        Lan1: false,
        Lan1Mode: "tag",
        Lan1Vlan: null,
        Lan1VlanT: null,
        Lan2: false,
        Lan2Mode: "tag",
        Lan2Vlan: null,
        Lan2VlanT: null,
        Lan3: false,
        Lan3Mode: "tag",
        Lan3Vlan: null,
        Lan3VlanT: null,
        Lan4: false,
        Lan4Mode: "tag",
        Lan4Vlan: null,
        Lan4VlanT: null,
        sfuTip: false,
        manageIp: false,
        manageIpVlan: null,
        manageIpAddr: null,
        manageIpMask: null,
        manageIpGateway: null,
      },
      usertype: 1, // 0: 普通用户 1: 超级用户
      select_lang: "English",
      iBox: {},
      lastTime: new Date().getTime(),
      currentTime: new Date().getTime(),
      timeOut: 10 * 60 * 1000, //设置超时时间： 10分
      tiHandle: null,
      toHandle: null,
    }
  },
  created() {
    document.title = "GPON OLT"
    this.init()
  },

  methods: {
    input_vlanid_check(vlan) {
      if (vlan == null) return null
      if (isNaN(vlan) || vlan < 2 || vlan > 4094)
        return "VLAN ID must be between 2-4094."

      return null
    },
    input_hgu_vlan_check(i) {
      if (i < 0 || i > 2) return null

      var v = ["HSI", "SIP", "IPTV"]

      if (!this.fastconfig[v[i]] || this.fastconfig[v[i] + "Vlan"] == null)
        return null

      var re = this.input_vlanid_check(this.fastconfig[v[i] + "Vlan"])
      if (re) return re

      for (var j = 0; j <= 2; j++) {
        if (
          i == j ||
          !this.fastconfig[v[j]] ||
          this.fastconfig[v[j] + "Vlan"] == null
        )
          continue
        if (this.fastconfig[v[i] + "Vlan"] == this.fastconfig[v[j] + "Vlan"])
          return "VLAN ID is the same as " + v[j] + "!"
      }

      return null
    },
    input_ip_check(ip) {
      if (ip == null) return null

      if (
        ip.match(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) == null
      ) {
        return "ip address must be inputted with A.B.C.D "
      } else {
        var id = ip.split(".")
        let ip0 = Number(id[0])
        let ip1 = Number(id[1])
        let ip2 = Number(id[2])
        let ip3 = Number(id[3])
        if (
          ip0 < 0 ||
          ip0 > 255 ||
          ip1 < 0 ||
          ip1 > 255 ||
          ip2 < 0 ||
          ip2 > 255 ||
          ip3 < 0 ||
          ip3 > 255
        )
          return "invalid ip address"
      }

      return null
    },
    input_ipmask_check(ip) {
      if (ip == null) return null

      if (
        ip.match(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) == null
      ) {
        return "ip mask must be inputted with A.B.C.D "
      } else {
        var id = ip.split(".")
        let ip0 = Number(id[0])
        let ip1 = Number(id[1])
        let ip2 = Number(id[2])
        let ip3 = Number(id[3])
        if (
          ip0 < 0 ||
          ip0 > 255 ||
          ip1 < 0 ||
          ip1 > 255 ||
          ip2 < 0 ||
          ip2 > 255 ||
          ip3 < 0 ||
          ip3 > 255
        )
          return "invalid ip mask"
      }

      return null
    },
    input_manageIp_check(i) {
      if (this.fastconfig["manageIp" + (!i ? "Addr" : "Gateway")] == null)
        return null
      var re = this.input_ip_check(
        this.fastconfig["manageIp" + (!i ? "Addr" : "Gateway")]
      )
      if (re) return re

      if (
        this.fastconfig["manageIp" + (i ? "Addr" : "Gateway")] == null ||
        this.input_ip_check(
          this.fastconfig["manageIp" + (i ? "Addr" : "Gateway")]
        )
      )
        return null

      var addr = this.fastconfig.manageIpAddr.split(".")
      var gateway = this.fastconfig.manageIpGateway.split(".")

      if (
        Number(addr[0]) == Number(gateway[0]) &&
        Number(addr[1]) == Number(gateway[1]) &&
        Number(addr[2]) == Number(gateway[2]) &&
        Number(addr[3]) == Number(gateway[3])
      )
        return (
          "The IP address is the same as " + (i ? "manage IP" : "gataway") + "!"
        )

      return null
    },
    hguNext() {
      if (
        !this.fastconfig.HSI &&
        !this.fastconfig.SIP &&
        !this.fastconfig.IPTV
      ) {
        this.fastconfig.hguTip = true
        return
      }

      var v = ["HSI", "SIP", "IPTV"]
      for (var k in v) {
        if (
          (this.fastconfig[v[k]] && this.fastconfig[v[k] + "Vlan"] == null) ||
          this.input_hgu_vlan_check(Number(k))
        ) {
          document.getElementById("fastconfig_" + v[k] + "_vlan").focus()
          return
        }
      }
      this.fast_dialog += 2
    },
    sfuNext() {
      if (
        !this.fastconfig.Lan1 &&
        !this.fastconfig.Lan2 &&
        !this.fastconfig.Lan3 &&
        !this.fastconfig.Lan4
      ) {
        this.fastconfig.sfuTip = true
        return
      }

      var v = ["Lan1", "Lan2", "Lan3", "Lan4"]
      for (var k in v) {
        if (this.fastconfig[v[k]]) {
          if (
            this.fastconfig[v[k] + "Vlan"] == null ||
            this.input_vlanid_check(this.fastconfig[v[k] + "Vlan"])
          ) {
            document.getElementById("fastconfig_" + v[k] + "_vlan").focus()
            return
          }
          if (
            this.fastconfig[v[k] + "Mode"] === "translate" &&
            (this.fastconfig[v[k] + "VlanT"] == null ||
              this.input_vlanid_check(this.fastconfig[v[k] + "VlanT"]))
          ) {
            document.getElementById("fastconfig_" + v[k] + "_vlanT").focus()
            return
          }
        }
      }
      this.fast_dialog += 1
    },
    clkApply() {
      if (this.fastconfig.manageIp) {
        var v = ["Vlan", "Addr", "Mask", "Gateway"]
        var r = [
          this.input_vlanid_check(this.fastconfig["manageIp" + v[0]]),
          this.input_manageIp_check(0),
          this.input_ipmask_check(this.fastconfig["manageIp" + v[2]]),
          this.input_manageIp_check(1),
        ]
        for (var k in v) {
          if (this.fastconfig["manageIp" + v[k]] == null || r[k]) {
            document.getElementById("fastconfig_manageIp" + v[k]).focus()
            return
          }
        }
      }
      /*
      if (this.input_vlanid_check() || this.fastconfig.vlan == null) {
        if (this.fastconfig.vlan == null) this.fastconfig.vlan = ""
        document.getElementById("fastconfig_vlan").focus()
        return
      }
      
      if (this.fastconfig.port == "") {
        var el = document.getElementById("fastconfig_port")
        //el.parentElement.classList.add("has-error")
        el.focus()
        return
      }
      */
      var postData = {
        isSfu: this.fastconfig.ontsfumode,
      }

      var v = postData.isSfu
        ? ["Lan1", "Lan2", "Lan3", "Lan4"]
        : ["HSI", "SIP", "IPTV"]
      for (var k in v) {
        if (this.fastconfig[v[k]]) {
          postData[v[k] + "Mode"] = this.fastconfig[v[k] + "Mode"]
          postData[v[k] + "Vlan"] = Number(this.fastconfig[v[k] + "Vlan"])
          if (postData[v[k] + "Mode"] === "translate")
            postData[v[k] + "VlanT"] = Number(this.fastconfig[v[k] + "VlanT"])
        }
      }

      if (this.fastconfig.manageIp) {
        var v = ["Vlan", "Addr", "Mask", "Gateway"]
        for (var k in v)
          if (v[k] == "Vlan")
            postData["manageIp" + v[k]] = Number(
              this.fastconfig["manageIp" + v[k]]
            )
          else postData["manageIp" + v[k]] = this.fastconfig["manageIp" + v[k]]
      }

      post("fastconfig", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config Successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              res.data.code === 0 ? "Info" : "Warn",
              res.data.msg !== undefined ? res.data.msg : "Unknow error!"
            )
          this.init()
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.need_fastconfig = false
    },
    init() {
      get("userstatus")
        .then((res) => {
          if (
            localStorage.userid === undefined ||
            !res.data["islogin"] ||
            localStorage.userid !== res.data["userid"]
          ) {
            this.$router.push("/login")
            return
          }
          this.username = res.data["username"]
          this.usertype = window.usertype = res.data["usertype"]
          this.ponnum = res.data["ponnum"]
          this.need_fastconfig = res.data["need_fastconfig"]
          // this.currentUrl = this.validMenu[0].url
          // this.expandMenu = this.validMenu[0].url
          this.currentUrl = this.$route.path.slice(1)
          this.expandMenu = this.validMenu.find((m) =>
            m["subs"].length
              ? m["subs"].find((subM) => subM.url === this.currentUrl)
              : m.url === this.currentUrl
          ).url
        })
        .catch((err) => {})
    },

    logout() {
      post("logout")
        .then((res) => {
          this.$router.push("/login")
        })
        .catch((err) => {
          this.$router.push("/login")
        })
    },

    getUserId() {
      get("userid")
        .then((res) => {
          if (
            !res.data["islogin"] ||
            res.data["userid"] !== localStorage.userid
          ) {
            this.$router.push("/login")
            return
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    timeoutCheck() {
      this.currentTime = new Date().getTime() //更新当前时间
      if (this.currentTime - this.lastTime > this.timeOut) {
        //判断是否超时
        this.logout()
      }
    },

    clearTimeout() {
      this.lastTime = new Date().getTime()
    }, //更新操作时间

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },

  beforeDestroy() {
    clearInterval(this.tiHandle)
    clearInterval(this.toHandle)
  },

  mounted() {
    /* 设置超时退出，定时器  间隔1秒检测是否长时间未操作页面  */
    this.tiHandle = window.setInterval(this.getUserId, 3000)
    this.toHandle = window.setInterval(this.timeoutCheck, 1000)

    document.onclick = this.clearTimeout
    document.onmousemove = this.clearTimeout
    document.onkeypress = this.clearTimeout
  },

  computed: {
    menuData() {
      return [
        {
          title: "Home",
          icon: "fa fa-home",
          url: "home",
          subs: [
            {
              title: "Home",
              url: "home",
            },
            {
              title: "Device Status",
              url: "devicestatus",
            },
          ],
        },
        {
          title: "OLT Configuration",
          icon: "fa fa-server",
          url: "vlan",
          subs: [
            {
              title: "VLAN",
              url: "vlan",
            },
            {
              title: "Port",
              url: "port",
            },
            {
              title: "MAC",
              url: "mac",
            },
            {
              title: "LACP",
              url: "lacp",
            },
            {
              title: "IGMP",
              url: "igmp",
            },
            {
              title: "STP",
              url: "stp",
            },
            {
              title: "IP Config",
              url: "ipconfig",
            },
            {
              title: "DHCP",
              url: "dhcp",
            },
            {
              title: "DHCP Option82",
              url: "dhcpoption82",
            },
            {
              title: "PPPoE Plus",
              url: "pppoeplus",
            },
            {
              title: "SNMP",
              url: "snmpconfig",
            },
            /*
            {
              title: "IP Route",
              url: "#/#/iproute",
            },
            
            {
              title: "IPV6 Route",
              url: "#/#/ipv6route",
            },
            */
            {
              title: "Storm Control",
              url: "stormcontrol",
            },
            {
              title: "GPON Config",
              url: "gponconfig",
            },
          ],
        },
        {
          title: "ONT Configuration",
          icon: "fa fa-hdd-o",
          url: "ontbrief",
          subs: [
            {
              title: "ONT List",
              url: "ontbrief",
            },
            {
              title: "ONT Optical Info",
              url: "ontOptical",
            },
            {
              title: "ONT MacAddress Table",
              url: "ontmactablelist",
            },
            {
              title: "ONT Upgrade",
              url: "ontupgrade",
            },
          ],
        },
        {
          title: "Profile Configuration",
          icon: "fa fa-file-text-o",
          url: "profilevlan",
          subs: [
            {
              title: "VLAN Profile",
              url: "profilevlan",
            },
            {
              title: "DBA Profile",
              url: "profiledba",
            },
            {
              title: "US Profile",
              url: "profileus",
            },
            {
              title: "DS Profile",
              url: "profileds",
            },
            {
              title: "Line Profile",
              url: "profilelinepri",
            },
            {
              title: "Rule Profile",
              url: "profilerule",
            },
            {
              title: "Unique Profile",
              url: "profileunique",
            },
            {
              title: "Alarm Profile",
              url: "profilealarm",
            },
            {
              title: "Multicast Profile",
              url: "profilemulticast",
            },
          ],
        },
        {
          title: "System Management",
          icon: "fa fa-gears",
          url: "devicemanagement",
          subs: [
            {
              title: "Device Management",
              url: "devicemanagement",
              needsuper: true,
            },
            {
              title: "User Management",
              url: "userconfig",
              needsuper: true,
            },
            {
              title: "AUX IP",
              url: "auxip",
            },
            {
              title: "System Time",
              url: "systemTime",
            },
            {
              title: "Mirror",
              url: "mirrorCfg",
            },
            {
              title: "Diagnose",
              url: "diagnose",
            },
          ],
        },
      ]
    },
    validMenu() {
      if (this.usertype === 1) return this.menuData

      let validM = []

      this.menuData.forEach((menu) => {
        if (menu["needsuper"] === true) return

        let newMenu = Object.create(menu)
        validM.push(newMenu)
        newMenu["subs"] = menu["subs"].filter(
          (subM) => subM["needsuper"] !== true
        )
        if (newMenu["subs"].length) newMenu["url"] = newMenu["subs"][0]["url"]
        else if (menu["subs"].length) menu["needsuper"] = true
      })

      return validM.filter((menu) => menu["needsuper"] !== true)
    },
  },
}
</script>

<style lang="less" >
.frame {
  font-family: Source Sans Pro, Georgia, "Times New Roman", "Microsoft YaHei",
    "黑体", "微软雅黑", STXihei, "华文细黑", serif !important;
  font-weight: Light;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  .frame-in {
    color: slategrey;
    width: 100%;
    height: 100%;
    position: relative;

    /* 框左侧缩进样式 */
    .menu-mini {
      .frame-left {
        left: -250px;
      }
    }
    /* 框左侧样式 */
    .frame-left {
      background-color: #343239;
      overflow-y: auto;
      overflow-x: hidden;
      font-size: 14pt;
      font-weight: lighter;
      color: #bdc2d5;
      float: left;
      width: 250px;
      height: 100%;
      z-index: 999;
      transition: width 0.5s;
      -webkit-transition: width 0.5s;
      position: absolute;
      left: 0px;
      /*box-shadow: -10px -9px 55px -13px black inset;*/
      a {
        color: #ffffff;
        text-decoration: none;
        display: inline-block;
        width: 197px;
      }
      .frame-menu-pannel {
        height: 60px;
        line-height: 60px;
        padding-left: 85px;
        transition: padding-left 0.5s;
        -webkit-transition: padding-left 0.5s;
      }
      .frame-menu-list {
        width: 250px;
        /*box-shadow: -40px 0px 55px -40px black inset;*/
        .frame-menu-item:last-child > .sub-item-list {
          border: none;
        }
        .frame-menu-item {
          border-left: 7px solid transparent;
          .frame-menu-item-title-active {
            color: #20b2aa;
          }
          .frame-menu-item-title {
            height: 40px;
            line-height: 40px;
            padding-left: 8px;
            /*border-top: 1px solid #5a595e;*/
            i {
              text-align: center;
              display: inline-block;
              font-size: 20px;
              width: 20px;
              height: 20px;
            }
            a {
              display: inline-block;
              margin-left: 10px;
              white-space: nowrap;
              width: 197px;
              border-top: 1px solid #5a595e;
            }
          }
          .frame-sub-item-list {
            overflow: hidden;
            padding-left: 47px;
            transition: height 0.5s;
            -webkit-transition: height 0.5s;
            .frame-sub-item {
              font-size: 14pt;
              height: 40px;
              line-height: 40px;
              .frame-sub-item-active {
                color: #20b2aa;
              }
            }
          }
        }
        .frame-menu-item-active {
          border-left: 7px solid #20b2aa;
          i.fa {
            color: #20b2aa;
          }
        }
      }
    }

    /* 框右侧样式 */
    .frame-right {
      transition: left 0.1s;
      -webkit-transition: left 0.1s;
      position: absolute;
      left: 250px;
      right: 0px;
      height: 100%;
      min-width: 768px;
      &.frame-right-stretch {
        left: 0px;
      }
      .frame-right-in {
        height: 100%;

        /* 框右侧顶部样式 */
        .frame-right-top {
          background-color: white;
          position: relative;
          color: #000;
          height: 60px;
          right: 0px;
          line-height: 60px;
          /*border-bottom: 1px solid #ccc;*/
          .frame-log-icon {
            padding: 0px 20px;
            img {
              vertical-align: middle;
            }
          }
          .frame-product-title {
            font-weight: normal;
            font-size: 18px;
            color: #71757f;
            /*text-shadow: 0px 0px 1px gray;*/
          }

          /* 框右侧顶部右侧样式 */
          .frame-right-top-right {
            float: right;
            margin-right: 20px;
            span {
              color: #71757f;
              font-weight: regular;
              font-size: 14pt;
            }
            select {
              margin-right: 6px;
              display: inline;
              width: 80px;
              padding: 0;
              height: auto;
            }
            i {
              color: #008b8b;
              font-size: 22px;
              padding: 0 5px;
              top: 6px;
              cursor: pointer;
            }
          }
        }

        /* 框右侧主体部分样式 */
        .frame-right-main {
          position: absolute;
          overflow: auto;
          top: 60px;
          bottom: 0px;
          width: 100%;
          background: #f3f3f4;
          .frame-right-main-page {
            margin: 0 30px;
          }
        }
      }
    }
    /* 框公共样式 */
    .frame-float-clear:after {
      content: " ";
      display: block;
      visibility: hidden;
      clear: both;
      width: 0px;
      height: 0px;
    }
    .frame-inline-block {
      display: inline-block;
    }
    .frame-roate {
      transform: rotate(-180deg);
      transition: all 0.5s ease-in-out;
    }
    .frame-roatecol {
      transform: rotate(0deg);
      transition: all 0.5s ease-in-out;
    }
    .frame-relative {
      position: relative;
    }
  }
}
</style>